import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { UiKitModule } from '../../../../shared/ui-kit/ui-kit.module';
import { ActiveOrganization, UserOrganizationDropDown } from '@models/organization.model';
import { FormControl } from '@angular/forms';
import { AuthenticationService } from '../../../../authentication/authentication.service';
import { Router } from '@angular/router';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { smartSearch } from '../../../../helpers/common.helpers';
import { LetDirective } from '@ngrx/component';
import { TranslatePipe } from '@ngx-translate/core';
import { TruncateDirective } from '../../../../shared/directives/truncate.directive';

@Component({
  selector: 'app-switch-organization',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    UiKitModule,
    LetDirective,
    TruncateDirective,
    TranslatePipe,
  ],
  templateUrl: './switch-organization.component.html',
  styleUrl: './switch-organization.component.scss',
})
export class SwitchOrganizationComponent implements OnInit, AfterViewInit {

  @Input() activeOrganization: ActiveOrganization;

  @Input() userOrganizations: UserOrganizationDropDown[];
  @Input() position: 'left' | 'right' = 'left'
  public filteredUserOrganizations$: Observable<UserOrganizationDropDown[]>;

  @Output() onMenuClosed: EventEmitter<any> = new EventEmitter<any>();
  private searchOrganizationFormControl: FormControl = new FormControl<any>([]);

  @ViewChild('uiSearchComponent') uiSearchComponent: HTMLElement;

  constructor(private authenticationService: AuthenticationService,
              private router: Router,
  ) {
  }

  public ngOnInit() {
    this.filteredUserOrganizations$ = combineLatest([
      this.searchOrganizationFormControl.valueChanges
        .pipe(startWith('')),
    ])
      .pipe(map(([query]) => {
        return smartSearch(this.userOrganizations, query, 'name');
      }));
  }

  public ngAfterViewInit() {
    this.uiSearchComponent?.focus();
  }

  public onSearchOrganizationInput(query: string) {
    this.searchOrganizationFormControl.patchValue(query);
  }

  public async switchOrg(id: string) {
    this.onMenuClosed.emit();
    await this.authenticationService.switchTenant(id, true);
  }

  public createOrganization(): void {
    this.router.navigate(['/organization/create-organization/step1']);
  }
}
